
















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { BackStoryData } from '../../../module/backStory';

@Component
export default class Presentational extends Vue {
  @Prop() public label!: string;
  @Prop() public annotation!: string;
  @Prop() public datas!: string[];
}
